import { ReactNode } from 'react';
import { useFormatter, useTranslations } from 'use-intl';
import Link from 'next/link';
import { Chain } from 'viem';

export interface StakeProps {
  chain: Chain;
  view: 'stake' | 'unstake';
  stakeForm: ReactNode;
  unstakeForm: ReactNode;
  chart: ReactNode;
  supplyLocked: number | null;
  averageLockTime?: number;
}

const Stake = ({
  chain,
  view,
  stakeForm,
  unstakeForm,
  chart,
  supplyLocked,
  averageLockTime,
}: StakeProps) => {
  const t = useTranslations('Stake');
  const { number } = useFormatter();

  return (
    <div>
      <header className="p-4 md:p-10 md:flex mb-6 md:mb-0">
        <h1 className="text-4xl font-medium md:w-[20%] mb-6 md:mb-0">
          {t('title')}
        </h1>
        <dl className="grid grid-cols-2 md:grid-cols-3 gap-4 ml-auto flex-1">
          <div>
            <dd className="font-display text-brand-blue font-normal">
              {supplyLocked
                ? number(supplyLocked, {
                    style: 'percent',
                    maximumFractionDigits: 4,
                  })
                : '-'}
            </dd>
            <dt className="text-sm font-semibold">{t('supplyLocked')}</dt>
          </div>

          <div>
            <dd className="font-display text-brand-blue font-normal">
              {averageLockTime
                ? `${number(averageLockTime * 2)} ${
                    chain.testnet ? 'days' : 'weeks'
                  }`
                : '-'}
            </dd>
            <dt className="text-sm font-semibold">{t('averageLockTime')}</dt>
          </div>
        </dl>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-10 gap-4">
        <div className="rounded-xl bg-gradient-to-br from-brand-blue/40 via-brand-blue/10 to-brand-blue/10 col-span-1 lg:col-span-4">
          <nav className="border-b border-gray-400 px-6 space-x-4 flex">
            <button
              className={`px-4 py-5 font-medium text-sm border-b -mb-px text-gray-200 border-transparent cursor-not-allowed`}
              type="button"
              disabled={true}
            >
              {t('stake')}
            </button>
            <Link
              href={`/unstake`}
              className={`px-4 py-5 font-medium text-sm border-b -mb-px ${
                view === 'unstake'
                  ? 'text-white border-brand-blue'
                  : 'text-gray-200 border-transparent hover:border-brand-blue/50 hover:text-gray-100'
              }`}
            >
              {t('unstake')}
            </Link>
          </nav>
          <section className="py-6 px-4">
            {view === 'stake' && stakeForm}
            {view === 'unstake' && unstakeForm}
          </section>
        </div>
        {/* <div className="rounded-xl bg-gray-800 col-span-1 lg:col-span-6 flex flex-col">
          <h2 className="border-b border-gray-400 px-6  py-5 text-sm">
            {t('graph.title')}
          </h2>
          <section className="p-6 relative flex-1">{chart}</section>
        </div> */}
      </div>
    </div>
  );
};

export default Stake;
